import { createReducer } from '@reduxjs/toolkit';
import { api } from './helpers/api';

// Action Types
const COUNTRIES_REQUEST = 'countries/request';
const COUNTRIES_SUCCESS = 'countries/success';
const COUNTRIES_FAILURE = 'countries/failure';

// Actions
export const requestCountries = () => ({ type: COUNTRIES_REQUEST });
export const receiveCountries = (data) => ({
  type: COUNTRIES_SUCCESS,
  payload: { data }
});
export const countriesError = (error) => ({
  type: COUNTRIES_FAILURE,
  payload: { error: error?.message || "Failed to load countries" }
});

// Initial State
const initialState = {
  items: [],
  loading: false,
  error: null,
};

// Reducer
export default createReducer(initialState, {
  [COUNTRIES_REQUEST]: (state) => {
    state.loading = true;
    state.error = null;
  },
  [COUNTRIES_SUCCESS]: (state, { payload }) => {    
    state.loading = false;
    state.items = payload.data || [];
  },
  [COUNTRIES_FAILURE]: (state, { payload }) => {
    state.loading = false;
    state.error = payload.error;
  },
});

// Thunks
export const fetchCountries = () => async (dispatch) => {
  try {
    dispatch(requestCountries());
    const response = await dispatch(
      api({
        url: '/countries',
        method: 'get',
        noAuth: true,
      })
    );
    dispatch(receiveCountries(response));
    return response;
  } catch (error) {
    dispatch(countriesError(error));
    throw error;
  }
};

// Selectors
export const selectCountries = (state) => state.countries.items;
export const selectCountriesLoading = (state) => state.countries.loading;
export const selectCountriesError = (state) => state.countries.error;
export const selectCountriesPagination = (state) => state.countries.pagination;
